import React from "react";
import { Dialog } from "@gonoodle/gn-universe-ui";

import ChampionSelect from "./ChampionSelect";
import { useChampions, useActiveProfile } from "../hooks";

export default function GraduatedChampSelection({ champ, onChampSelected }) {
  const { champions } = useChampions();
  const currentProfile = useActiveProfile();
  const unavailableChampionsIDs = currentProfile.graduatedChampIds.concat([
    champ.champId,
  ]);
  const defaultChampion = champions.find(
    (c) => !unavailableChampionsIDs.includes(c.id),
  );

  function handelSelectedChampionChange(champion) {
    onChampSelected(champion.id);
  }

  return (
    <Dialog.Root className="z-50 px-0 items-stretch" isOpen>
      <Dialog.Content className="bg-gray-900 overflow-auto w-screen h-screen">
        <div className="w-full h-full p-md">
          <Dialog.Title className="font-display text-2xl lg:text-4xl mb-xl lg:mt-lg text-white text-center capitalize">
            Time to pick a new champ!
          </Dialog.Title>
          <ChampionSelect
            defaultSelectedChampion={defaultChampion}
            unavailableChampionsIDs={unavailableChampionsIDs}
            onChange={handelSelectedChampionChange}
          />
        </div>
      </Dialog.Content>
    </Dialog.Root>
  );
}
